export default {
  hasSubscription: (state) => !!state.subscription && !state.subscription.expiredAt,
};
